import {
  CompanyAutocomplete,
  CompanyAutocompleteProps,
  ImoClassAutoComplete,
  ImoClassAutoCompleteProps,
  LocationCodeAutoComplete,
  LocationCodeAutoCompleteProps,
} from '@tom-ui/planning'
import { AllocationRuleTemplateFormPage } from '@tom-ui/yard'

export const AllocationRuleTemplateFormView = () => {
  return (
    <AllocationRuleTemplateFormPage
      companyAutoComplete={(props: CompanyAutocompleteProps) => <CompanyAutocomplete {...props} />}
      locationCodeAutoComplete={(props: LocationCodeAutoCompleteProps) => (
        <LocationCodeAutoComplete {...props} />
      )}
      imoClassAutoComplete={(props: ImoClassAutoCompleteProps) => (
        <ImoClassAutoComplete {...props} />
      )}
    />
  )
}
